import { GeneralSetting } from '@apis/index'
import Button from '@components/button'
import Card from '@components/card'
import Fields from '@components/fields'
import Row from '@components/row'
import { cardStyle, StyleCardTitle, StyleColumn } from '@components/styles'
import { SeoSchema } from '@validations/index'
import { Form, Formik } from 'formik'
import { useState } from 'react'

const AdminFooterForm = ({ data, pageKey }: any) => {
  const [loading, setLoading] = useState(false)
  const submitHandler = async (values: any) => {
    setLoading(true)
    const payload = {
      title: 'footer',
      key: pageKey,
      value: values?.description,
    }
    try {
      if (data?.value) {
        await GeneralSetting.update(pageKey, payload, data?.id)
      } else {
        await GeneralSetting.create(pageKey, payload)
      }
    } catch (error) {
      console.error('Error during save:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Card customStyle={cardStyle}>
        <StyleCardTitle>Footer</StyleCardTitle>
        <Formik
          enableReinitialize
          initialValues={{ description: data?.value }}
          onSubmit={submitHandler}
          validationSchema={SeoSchema.footerValidation}
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <StyleColumn>
                <Fields.TextArea
                  name="description"
                  height={150}
                  placeholder="Enter Description"
                  label="Description"
                />
                <Row justifyContent="flex-end">
                  <Button
                    title="Save"
                    loading={loading}
                    type="submit"
                    height={40}
                  />
                </Row>
              </StyleColumn>
            </Form>
          )}
        </Formik>
      </Card>
    </>
  )
}

export default AdminFooterForm
